import { createFeature, createReducer } from '@ngrx/store';

import { userPageMergeConflictDialogReducers } from './user-page-merge-conflict-dialog.reducer';
import { userPageMergeConflictDialogInitialState } from './user-page-merge-conflict-dialog.state';

export const userPageMergeConflictDialogFeature = createFeature({
    name: 'userPageMergeConflictDialog',
    reducer: createReducer(userPageMergeConflictDialogInitialState, ...userPageMergeConflictDialogReducers),
});
